import type { FaireProductEntity } from "../../entity_types/product";

export const p_d64ctr2yzr: FaireProductEntity = {
  token: "p_d64ctr2yzr",
  type: "product",
  name: "Thank You Gifts Leopard Hair Coils Telephone Cord Hair Ties",
  brandToken: "b_cllfpw8grf",
  brandName: "Tiny Gift Society",
  imageUrl:
    "https://cdn.faire.com/fastly/11c89bf0973bbb2f622910257f73833a29898351590345478fa053cf63fec1ed.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/a008ed15a343b4cf5e7274a5a1723bb323f157984c81c9881207c53e3a7cc8ca.jpeg",
    "https://cdn.faire.com/fastly/23c133fcfabc851c3f0de2530a8d3018132fb7becf34d047be13b8848c947f91.jpeg",
    "https://cdn.faire.com/fastly/debfc5a81e1cee085cd0cb4132169a310f8a1c64f9faa25218f8a1580554e0cd.jpeg",
    "https://cdn.faire.com/fastly/0344980271eb14d0f6b0777e6dfbe27aaf97b825cf7802b534cc90798c015157.jpeg",
    "https://cdn.faire.com/fastly/9c7869d75a473ef35edce1de3a2daa1208831da553d41eb21d10a7067f8432b5.jpeg",
    "https://cdn.faire.com/fastly/6624cb7551c46168a5a151215aead732e1275aeaf5d3c47ddc7e749464ba5f49.jpeg",
  ],
  priceDollars: 1.32,
  description:
    "One of the BEST popular thank you gift for small businesses - Hair Coils!  These are large sized and leopard print!\n\nEach set of 10pc, comes with 4 brown, 3 white, and 3 black.\nNOT FOR RESALE, use as thank you gifts for customers only.\n\nStylish and sturdy hair ties are probably THE most practical gift.  They are about the size of a quarter and work perfectly for women, teens, and girls.\n\nTagged with a kraft, hand-stamped label.\n\nA great way for boutiques to give customer appreciation thank you gifts for women.\n\nAssorted Colors; Randomly Selected\n\nGreat for:\n- Thank You Gifts\n- Customer Appreciation Gifts\n- Hair Ties / Hair Accessories\n- Table Fillers\n- Sub Boxes (Subscription Boxes)\n- Women Teens Girls",
  tags: [],
  msrpDollars: 2.63,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:56:41.618Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
